<template>
    <div class="modal fade" :class="{'is-open': open}">
        <div class="modal-dialog">
            <div v-if="open" class="modal-content">
                <div class="modal-header">
                    <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
                    <h3 class="modal-title">客戶通聯資料</h3>
                </div>
                <div class="modal-body">
                    <table class="table insurance-green">
                        <tr>
                            <th class="text-green text-right" width="14%">類別</th>
                            <th class="text-green" width="21%">項目</th>
                            <th class="text-green" width="40%">內容</th>
                            <th class="text-green" width="25%">更新時間</th>
                        </tr>
                        <tr>
                            <th class="text-green text-right">手機號碼</th>
                            <td>手機號碼</td>
                            <td>{{addressData.mobile}}</td>
                            <td>{{addressData.mobile_update_date | dateToROCdateFormat}}<br>{{addressData.mobile_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="3">電話號碼</th>
                            <td>住家電話號碼</td>
                            <td>{{addressData.homeTel}}</td>
                            <td>{{addressData.tel_h_update_date | dateToROCdateFormat}}<br>{{addressData.tel_h_update_time}}</td>
                        </tr>
                        <tr>
                            <td>公司電話號碼</td>
                            <td>{{addressData.corpTel}}</td>
                            <td>{{addressData.tel_o_update_date | dateToROCdateFormat}}<br>{{addressData.tel_o_update_time}}</td>
                        </tr>
                        <tr>
                            <td>聯絡電話號碼</td>
                            <td>{{addressData.tel_p_bundle}}</td>
                            <td>{{addressData.tel_p_update_date | dateToROCdateFormat}}<br>{{addressData.tel_p_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">地址</th>
                            <td>收費地址</td>
                            <td>{{addressData.addr_p_postal_cd}}{{addressData.addr_p_city_nm}}{{addressData.addr_p_line_1}}{{addressData.addr_p_line_2}}</td>
                            <td>{{addressData.addr_p_update_date | dateToROCdateFormat}}<br>{{addressData.addr_p_update_time}}</td>
                        </tr>
                        <tr>
                            <td>戶籍地址</td>
                            <td>{{addressData.addr_h_postal_cd}}{{addressData.addr_h_city_nm}}{{addressData.addr_h_line_1}}{{addressData.addr_h_line_2}}</td>
                            <td>{{addressData.addr_h_update_date | dateToROCdateFormat}}<br>{{addressData.addr_h_update_time}}</td>
                        </tr>
                        <tr>
                            <td>聯絡地址</td>
                            <td>{{addressData.addr_c_postal_cd}}{{addressData.addr_c_city_nm}}{{addressData.addr_c_line_1}}{{addressData.addr_c_line_2}}</td>
                            <td>{{addressData.addr_c_update_date | dateToROCdateFormat}}<br>{{addressData.addr_c_update_time}}</td>
                        </tr>
                        <tr>
                            <td>最新一筆地址</td>
                            <td>{{addressData.addr_newest_postal_cd}}{{addressData.addr_newest_city_nm}}{{addressData.addr_newest_line_1}}{{addressData.addr_newest_line_2}}</td>
                            <td>{{addressData.addr_newest_update_date | dateToROCdateFormat}}<br>{{addressData.addr_newest_update_time}}</td>
                        </tr>
                        <tr>
                            <th class="text-green text-right" rowspan="4">email</th>
                            <td>email</td>
                            <td>{{addressData.email}}</td>
                            <td>{{addressData.email_update_date | dateToROCdateFormat}}<br>{{addressData.email_update_time}}</td>
                        </tr>
                    </table>
                    <p>資料來源依據單一資料庫，僅供查詢聯繫保戶使用，如資料有誤，請填聯繫單或A4變更申請書修正</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'IntegratedAddressModal',
    props: {
        open: {
            type: Boolean,
            default: false
        },
        addressData: {
            type: Object,
            defualt: () => {
                return {}
            },
        }
    },
    data () {
        return {
        }
    }
}
</script>

<style>

</style>
